<template>
	<div>
		<el-dialog class="custom-dialog todo-detail-dialog" append-to-body destroy-on-close :visible.sync="isSidebarActiveLocal">
			<div slot="title" class="flex justify-between items-center w-full">
				<span class="el-dialog__title break-normal">{{ data.name }}</span>
			</div>
			<div>
				<el-radio-group v-model="tabPosition" class="w-full flex">
					<el-radio-button class="flex-1" label="all">Sổ lệnh</el-radio-button>
					<el-radio-button class="flex-1" label="me">Lệnh của tôi</el-radio-button>
				</el-radio-group>
				<perfect-scrollbar ref="vueScrollBar" class="scroll-area--data-list">
					<div class="p-6 relative" v-if="data">
						<div v-if="tabPosition === 'all'">
							<vs-row class="mb-1">
								<vs-col vs-w="6" class="text-right">
									<label class="text-solid-gray-1 text-right pr-4">Mua</label>
								</vs-col>
								<vs-col vs-w="6" class="text-black">
									<label class="text-solid-gray-1 pl-4">Bán</label>
								</vs-col>
							</vs-row>
							<vs-row class="mb-1" v-for="(item, idx) in orders">
								<vs-col vs-w="4">
									<label class="text-solid-gray-1" v-if="item.buy">{{ $helper.numFormat(item.buy.volume) }}</label>
								</vs-col>
								<vs-col vs-w="2" class="text-right">
									<label class="text-solid-gray-1 pr-4" v-if="item.buy">{{ $helper.numFormat(item.buy.price) }}</label>
								</vs-col>
								<vs-col vs-w="2">
									<label class="text-solid-gray-1 pl-4" v-if="item.sell">{{ $helper.numFormat(item.sell.price) }}</label>
								</vs-col>
								<vs-col vs-w="4" class="text-right">
									<label class="text-solid-gray-1" v-if="item.sell">{{ $helper.numFormat(item.sell.volume) }}</label>
								</vs-col>
							</vs-row>
						</div>
						<div v-if="tabPosition === 'me'">
							<vs-row class="mb-1">
								<vs-col vs-w="3" class="text-black">
									<label class="text-solid-gray-1">TG</label>
								</vs-col>
								<vs-col vs-w="3" class="text-black">
									<label class="text-solid-gray-1">KL</label>
								</vs-col>
								<vs-col vs-w="2" class="text-black">
									<label class="text-solid-gray-1">Giá</label>
								</vs-col>
								<vs-col vs-w="2" class="text-black">
									<label class="text-solid-gray-1">M/B</label>
								</vs-col>
								<vs-col vs-w="2" class="text-black">
									<label class="text-solid-gray-1">TT</label>
								</vs-col>
							</vs-row>
							<vs-row class="mb-1" v-for="(item, idx) in myOrders">
								<vs-col vs-w="3">
									<label class="text-solid-gray-1">{{ $helper.momentFormatLocale(item.created_at, "D/M H:m") }}</label>
								</vs-col>
								<vs-col vs-w="3">
									<label class="text-solid-gray-1">{{ $helper.numFormat(item.quantity) }}</label>
								</vs-col>
								<vs-col vs-w="2">
									<label class="text-solid-gray-1 pr-4">{{ $helper.numFormat(item.price) }}</label>
								</vs-col>
								<vs-col vs-w="2">
									<label class="text-solid-gray-1 pl-4">{{ item.type == 1 ? "M" : "B" }}</label>
								</vs-col>
								<vs-col vs-w="2">
									<label class="text-solid-gray-1">{{ showOrderStatus(item.status) }}</label>
								</vs-col>
							</vs-row>
						</div>
						<!--<PondsListView v-else class="w-full h-screen" />-->
					</div>
				</perfect-scrollbar>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import PondsListView from "../ponds/PondsListView.vue";
const userDefaults = {
	ward: "",
	district: "",
	province: "",
};
export default {
	name: "CustomerDetail",
	components: { PondsListView },
	props: {
		tabDefault: {
			type: String,
			default: "all",
		},
		isSidebarActive: {
			type: Boolean,
			required: true,
		},
		data: {
			type: Object,
			default: () => {},
		},
	},

	data() {
		if (this.tabDefault === "all") {
			this.getOrderByProduct();
		}
		if (this.tabDefault === "me") {
			this.getCustomerPonds();
		}
		return {
			tabPosition: this.tabDefault || "all",
			orders: [],
			myOrders: [],
		};
	},
	computed: {
		isSidebarActiveLocal: {
			get() {
				// console.log("Customer deiatal", this.data);

				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
				}
			},
		},
	},
	watch: {
		tabPosition() {
			if (this.tabPosition === "all") {
				this.getOrderByProduct();
			}
			if (this.tabPosition === "me") {
				this.getCustomerPonds();
			}
		},
	},
	methods: {
		showOrderStatus(status) {
			let name = "Đang chờ";
			switch (status) {
				case 0: {
					name = "Chờ";
					break;
				}
				case 1: {
					name = "Khớp";
					break;
				}
				case 2: {
					name = "Hủy";
					break;
				}
			}
			return name;
		},
		getCustomerPonds() {
			// this.$vs.loading();
			this.$store.dispatch("moduleProduct/getOrdersByMe", { id: this.data.id, page: 1, limit: 500 }).then((orders) => {
				this.myOrders = orders.data;
			});
			// this.$vs.loading.close();
		},
		getOrderByProduct() {
			// this.$vs.loading();
			this.$store.dispatch("moduleProduct/getOrdersByProduct", this.data.id).then((orders) => {
				let sells = [];
				let buys = [];
				orders.forEach((order) => {
					let item = {
						volume: parseInt(order.volume),
						price: parseInt(order.price),
					};
					switch (order.type) {
						case 1: {
							buys.push(item);
							break;
						}
						case 2: {
							sells.push(item);
							break;
						}
					}
				});
				let sellSorted = sells.sort((a, b) => a.price - b.price);
				let buySorted = buys.sort((a, b) => b.price - a.price);
				let total = Math.max(sellSorted.length, buySorted.length);
				let finalData = [];
				for (let i = 0; i < total; i++) {
					let buyItem = buySorted.hasOwnProperty(i) ? buySorted[i] : null;
					let sellItem = sellSorted.hasOwnProperty(i) ? sellSorted[i] : null;
					finalData.push({
						buy: buyItem,
						sell: sellItem,
					});
				}
				this.orders = finalData;
			});
			// this.$vs.loading.close();
		},
	},
	created() {
		this.getOrderByProduct();
	},
};
</script>
<style lang="scss">
.el-radio-button__inner {
	width: 100%;
	border: none;
	border-radius: 0 0 0 0 !important;
}
[dir] .el-radio-button__inner {
	background: #e0e0e0;
}
</style>
